import { defineStore } from "pinia";
import {
  updateTask,
  getContactsForTask,
  setAssigneeStatusForTask,
  setWatchStatusForTask,
  unassignUserFromTask,
  getProtocolsForTask,
} from "@/api/task";
import type { Task } from "@/models/Task";
import type { TaskFilterAttributes } from "@/models/Filters";

interface TaskState {
  task_search_filter: TaskFilterAttributes | null;
}

export const useTaskStore = defineStore("task", {
  state: (): TaskState => ({
    task_search_filter: null,
  }),

  actions: {
    updateTaskSearchFilter(filters: TaskFilterAttributes | null) {
      this.task_search_filter = filters;
    },

    async updateTask(task: Partial<Task> & { id: string }) {
      const resp = await updateTask(task);
      return resp.data;
    },

    async getContactsForTask(id: string) {
      const resp = await getContactsForTask(id);
      return resp.data;
    },

    async getProtocolsForTask(id: string) {
      const resp = await getProtocolsForTask(id);
      return resp.data;
    },

    async setAssigneeStatusForTask(id: string, status: string, userId?: string) {
      const resp = await setAssigneeStatusForTask(id, status, userId);
      return resp.data;
    },

    async setWatchStatusForTask(id: string, status: 'watch' | 'unwatch') {
      const resp = await setWatchStatusForTask(id, status);
      return resp.data;
    },

    async unassignUserFromTask(id: string, userId: string) {
      const resp = await unassignUserFromTask(id, userId);
      return resp.data;
    },
  },
});
